import { GUIDHelpers } from '../../shared/utilities/developHelpers';
import { ReplaySubject, Subscription } from 'rxjs';

export class ImageInfo {
  extension: string;
  fileId: string;
  fileTypeId: string;
  originalName: string;
  path: string;
  fileAccess: string;
  parentId?: string; // only for tree view
}

export class EditImageFile {
  fileId: string;
  path: string;
  fileAccessId: string;
}

export class SingleOrDoubleClick {
  delay: number = 500;
  timer;
  preventSingle = false;
  singleClick(): boolean {
    this.timer = () => {
      setTimeout(() => {
        if (!this.preventSingle) { return true; }
        else { return false }
      }, this.delay)
    }
    return this.timer
  }
  doubleClick() {
    this.preventSingle = true;
    clearTimeout(this.timer);
  }
}

export class ImagesToTree {
  help = new GUIDHelpers();
  rootId = this.help.newGUID();
  folders: Array<ImageCategory>;
  pathToId: Object = {};
  idToPath: Object = {};
  images: Array<ImageInfo>;
  tree: TreeImageCategory;
  draggedFolder: TreeImageCategory;
  draggedImage: string;
  selectedFolder: string;
  viewFolder: TreeImageCategory;
  selectedFolderPath = new ReplaySubject<string>(1);
  private reorderFolders = new ReplaySubject<ReorderFolderObject>(1);
  parentMessenger = new ReplaySubject<MessageFormat>(1);

  emitFolderPath() {
    return this.selectedFolderPath
  }
  folderReorder() {
    return this.reorderFolders
  }
  messenger() {
    return this.parentMessenger
  }
  async createFolders(images: Array<ImageInfo>) {
    this.folders = [
      { name: 'root', id: this.rootId, parentId: null, folderPath: '', showChildren: true, right: '4d32156a-20fe-4601-8cc8-0a4711034d6b' }
    ];
    for (let x of Array.from(new Set(images.map(x => { return x.path })))) {
      if (x != null && x != '') {
        let path = x.split('/');
        for (var i = 0; i < path.length; i++) {
          if (!this.pathToId[path.slice(0, i + 1).join('/')]) {
            this.pathToId[path.slice(0, i + 1).join('/')] = this.help.newGUID()
            this.folders.push(
              {
                name: path[i],
                id: this.pathToId[path.slice(0, i + 1).join('/')],
                parentId: i > 0 ? this.pathToId[path.slice(0, i).join('/')] : this.rootId,
                folderPath: path.slice(0, i + 1).join('/'),
                showChildren: false,
                right: images.find(z => z.path == x).fileAccess
              }
            );
          }
        }
      }
    }
    this.images = images.map(x => {
      return { ...x, parentId: x.path != null && x.path != '' ? this.pathToId[x.path] : '' }
    })
    this.branch();
  }

  branch() {
    let a = {}
    this.folders.forEach(x => a[x.id] = x.folderPath)
    console.log(a)
    let cats = this.folders.map(x => {
      return {
        ...x,
        originalData: x,
        children: [],
        items: this.images.filter(y => x.id == this.rootId ? y.parentId == null || y.parentId == '' : y.parentId == x.id)
      }
    })
    this.unflatten(cats)
  }

  unflatten(arr) {
    var tree: any = [], mappedArr = {}, arrElem, mappedElem;
    // First map the nodes of the array to an object -> create a hash table.
    for (var i = 0, len = arr.length; i < len; i++) {
      arrElem = arr[i];
      mappedArr[arrElem.id] = arrElem;
      mappedArr[arrElem.id]['children'] = [];
    }
    for (var id in mappedArr) {
      if (mappedArr.hasOwnProperty(id)) {
        mappedElem = mappedArr[id];
        // If the element is not at the root level, add it to its parent array of children.
        if (mappedElem.parentId) {
          mappedArr[mappedElem['parentId']]['children'].push(mappedElem);
          mappedArr[mappedElem['parentId']]['children'] = mappedArr[mappedElem['parentId']]['children'].sort((a, b) => { a.name > b.name ? 1 : -1 })
          //console.log(mappedArr[mappedElem['parentId']]['children'])
        }
        // If the element is at the root level, add it to first level elements array.
        else {
          tree.push(mappedElem);
        }
      }
    }
    this.tree = tree;
    this.viewFolder = tree[0];
    this.selectedFolder = this.rootId;
    this.selectedFolderPath.next('');
    console.log(tree, this.pathToId)
    //this.flatten()
  }
  childEvent(event) {
    if (event.type) {
      switch (event.type) {
        case ('draggingFolder'): {
          this.draggedFolder = event.object;
          this.draggedImage = null;
          break
        }
        case ('dropped'): {
          if (!!this.draggedFolder && event.id != null && event.id != this.draggedFolder.id) {
            this.folders.find(x => x.id == this.draggedFolder.id).parentId = event.id;
            let toFolder = this.folders.find(x => x.id == event.id);
            this.reorderFolders.next({
              object: this.draggedFolder,
              path: toFolder.folderPath
            })
            this.draggedFolder = null;
          }
          if (!!this.draggedImage && event.id != null) {
            this.parentMessenger.next({
              type: 'dropImg',
              id: this.draggedImage,
              folder: event.object
            }
            )
          }
          break
        }
        case ('selectFolder'): {
          this.selectedFolder = event.folder.id;
          this.folders.find(x => x.id == event.folder.id).showChildren = true;
          this.viewFolder = event.folder;
          this.selectedFolderPath.next(event.folder.folderPath);
        }
      }
    }
    //console.log(event)
  }
}

export class ImageCategory {
  name: string;
  id: string;
  parentId: string;
  folderPath: string;
  showChildren: boolean;
  right: string;
}

export class TreeImageCategory extends ImageCategory {
  originalData: any;
  children: Array<TreeImageCategory>;
  items: Array<ImageInfo>;
}

interface SelectedCategory {
  id: string,
  name: string,
  originalName: string
}

interface ReorderFolderObject {
  path: string;
  object: TreeImageCategory;
}

interface MessageFormat {
  type: string;
  id: string;
  folder?: TreeImageCategory;
}
